import { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";

const DEFAULT_LOGO =
  "https://res.cloudinary.com/dghqjv5az/image/upload/v1669488290/mix/logossala/logo_xd33n7.png";

const HASH_CONFIG = {
  "hc3ap": { qrHost: "https://salaqueens.com" },
  "7dkb1": { s: "41", logo: DEFAULT_LOGO },
  "opq4v": { qrHost: "https://stop.sala.pe" },
  "ys19n": { s: "51", logo: DEFAULT_LOGO },
  "hb7qc": {
    s: "111",
    logo:
      "https://res.cloudinary.com/dghqjv5az/image/upload/c_fill,h_120/linkedwgt/logo/FaicuInbEpx2RiBkwLuQL0V2rFQWZn0W/Las_vegas.jpg",
  },
  "8fwj3": {
    s: "170",
    logo:
      "https://res.cloudinary.com/dghqjv5az/image/upload/v1669486363/mix/logossala/fargos_promo_jijblw_xqjrto.jpg",
  },
  "9dan8": {
    s: "192",
    logo:
      "https://res.cloudinary.com/dghqjv5az/image/upload/c_fill,h_120/linkedwgt/logo/kt9Bs6LSeDDMAlaHn0vhmtec13ITuQ0v/El_dorado.jpg",
  },
  "8erbr7": {
    s: "194",
    logo:
      "https://res.cloudinary.com/dghqjv5az/image/upload/c_fill,h_120/linkedwgt/logo/2TseLYyo5wMUwmNvwLFdXQfL9PR1Rzjr/fbfdde92-7ba0-49c5-8a30-e505af69ccfa.jpg",
  },
  "y7jn93": {
    s: "124",
    logo:
      "https://res.cloudinary.com/dghqjv5az/image/upload/c_fill,h_120/linkedwgt/foods/rNWIk2WcOVb4wcdEiZhTwWzDpjflJ0sU/logoKANTA.png",
  },
  "8sn3z6": { s: "270", logo: DEFAULT_LOGO },
  "h4xcqk": {
    s: "280",
    logo:
      "https://wgt-tmp-uploads.s3.amazonaws.com/foods/5YhqbKmKG63r0DR3RsEfuNlGh4vHhHJC/IMG-20250424-WA0011.png",
  },
  "zj8jh": { s: "300", logo: DEFAULT_LOGO },
  "x1cw4": { s: "301", logo: DEFAULT_LOGO },
  "99999": { s: "999", logo: DEFAULT_LOGO },
  "83MDS": {s: "390", logo: "https://wgt-tmp-uploads.s3.amazonaws.com/logo/m8bAqS9P4bTd633xdPck8AbEyC7sxrPs/LOGO1.jpg"},
  "plab2": {s: "241", logo: "https://wgt-tmp-uploads.s3.amazonaws.com/foods/PYx0AGaoF0cKdSaYER82KsZxZCN0lq9k/PUBLICIDAD_(6).png"},
  "94FS3": {s: "120", logo: "https://wgt-tmp-uploads.s3.amazonaws.com/logo/gqPryingYDLr4EQ9DYyOYNgk6AJEaeq2/SJ3.png"},
  "72KVHS": {s: "121", logo: "https://wgt-tmp-uploads.s3.amazonaws.com/logo/FN4KmhnPzJBQUuLslKMJFH6BbdHerzQS/SJ2.png"},
  "T9WBNI": {s: "122", logo: "https://wgt-tmp-uploads.s3.amazonaws.com/logo/k2iP8z0Y6ptVfwc5Mh7BfP7FmeT9lKlV/LOGO_SAN_JUAN_kopibs.png"},
  "97FB7D": {s: "123", logo: "https://wgt-tmp-uploads.s3.amazonaws.com/foods/4yTKr3zaKFxOlZ3TZS7OImmEKcwTtgAN/logoPALACIO.png"},
};

function safeSetLocalStorage(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    console.warn("No se pudo guardar en localStorage:", e);
  }
}

export default function RedirectToAppV2() {
  const navigate = useNavigate();
  const { hash, code } = useParams();

  const cfg = useMemo(() => HASH_CONFIG[hash || ""], [hash]);
  const isValid = Boolean(cfg);

  useEffect(() => {
    if (!cfg) return;

    if (cfg.s) safeSetLocalStorage("s", cfg.s);
    if (cfg.logo) safeSetLocalStorage("logo", cfg.logo);

    const encoded = code ? encodeURIComponent(code) : "";

    if (cfg.qrHost && encoded) {
      window.location.replace(`${cfg.qrHost}/lector-qr?code=${encoded}`);
      return;
    }

    const search = encoded ? `?code=${encoded}` : "";
    navigate(`/login${search}`, { replace: true });
  }, [cfg, code, navigate]);

  return (
    <div className="min-h-[40vh] grid place-items-center p-6">
      <div className="text-center">
        <div
          className="animate-spin rounded-full h-12 w-12 border-4 border-current border-t-transparent mx-auto mb-4"
          role="status"
          aria-label="Cargando"
        />
        <p className="text-lg">{isValid ? "Cargando…" : "Link inválido"}</p>
        {!isValid && (
          <button
            className="mt-4 px-4 py-2 rounded-2xl shadow text-sm"
            onClick={() => navigate(-1)}
          >
            Volver
          </button>
        )}
      </div>
    </div>
  );
}
